import { styled } from '@mui/material';

export const LeftBadge = styled('div')(({ theme: { config, palette } }) => ({
  position: 'absolute',
  left: '-1.75rem',
  top: '0rem',
  padding: '0.25rem 0.45rem',
  borderTopRightRadius: 2,
  borderBottomRightRadius: 2,
  borderTopLeftRadius: 5,
  borderBottomLeftRadius: 5,
  display: 'flex',
  alignItems: 'center',
  fontSize: config.textSizes.tertia,
  color: palette.button.text2,
  backgroundColor: palette.snackBar.primary,
  paddingRight: '0.9rem',
}));

export const ArrowLeft = styled('div')(({ theme: { palette } }) => ({
  position: 'absolute',
  right: '-1px',
  top: 'auto',
  bottom: 'auto',
  width: 0,
  height: 0,
  borderTop: '1.1rem solid transparent',
  borderBottom: '1rem solid transparent',
  borderRight: `0.6rem solid ${palette.background.paper}`,
}));
